import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    motorCategoryAll: [],
    motorCategory: {},
    currentPage: 1,
    totalPages: 1,
    rowsPerPage: 10,
    sortBy: "categoryName",
    sortOrder: "asc",
};

const motorCategorySlice = createSlice({
    name: "motorCategory",
    initialState,
    reducers: {
        setMotorCategoryAll: (state, action) => {
            state.motorRTOAll = action.payload;
        },
        setMotorCategory: (state, action) => {
            state.motorRTO = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
    },
})

export const { setMotorCategoryAll, setMotorCategory, setCurrentPage, setTotalPages, setRowsPerPage } = motorCategorySlice.actions;
export default motorCategorySlice.reducer;